import { Broker, CodeDeployment } from '@amzn/amazonmq-opsconsole-client';
import {
    Container,
    Icon,
    SpaceBetween
} from '@amzn/awsui-components-react';
import React from 'react';
import { StatusIndicatorColor, InstanceVisualizationNode } from '../../../../types';
import InstanceDetails from './InstanceDetails';

interface Props {
    node: InstanceVisualizationNode;
    asgLoading: boolean;
    deployments: CodeDeployment[];
    broker: Broker;
    getStatusColor: (state: string) => StatusIndicatorColor;
}

const NodeRenderer: React.FC<Props> = React.memo(({ node, asgLoading: loading, deployments, broker, getStatusColor }) => {
    if (node.type === 'regular') {
        return (
            <Container>
                <InstanceDetails
                    broker={broker}
                    instance={node.instance}
                    deployments={deployments}
                    loading={loading}
                    getStatusColor={getStatusColor}
                />
            </Container>
        );
    }

    if (node.type === 'replacement') {
        return (
            <SpaceBetween direction='horizontal' size='l' alignItems="center">
                {node.terminatingInstance && (
                    <>
                        <Container>
                            <InstanceDetails
                                broker={broker}
                                instance={node.terminatingInstance}
                                deployments={deployments}
                                loading={loading}
                                getStatusColor={getStatusColor}
                            />
                        </Container>
                        <Icon name="arrow-right" size="large" variant="normal" />
                    </>
                )}

                <Container>
                    <InstanceDetails
                        instance={node.pendingInstance}
                        deployments={deployments}
                        loading={loading}
                        getStatusColor={getStatusColor}
                        broker={broker}
                    />
                </Container>
            </SpaceBetween>
        );
    }

    return null;
}, (prevProps, nextProps) => {
    return (
        prevProps.node === nextProps.node &&
        prevProps.asgLoading === nextProps.asgLoading &&
        prevProps.deployments === nextProps.deployments &&
        prevProps.broker === nextProps.broker
    );
});

export default NodeRenderer;
